import { JSX, useState, useEffect, useRef } from "react";
import './Tabs.css'

interface TabsProps {
    activeTab: string;
    setActiveTab: (tab: string) => void;
    tabs: {
        name: string;
    }[];
    tabsStyle?: React.CSSProperties;
    tabStyle?: React.CSSProperties;
}

export const Tabs = ({ activeTab, setActiveTab, tabs, tabsStyle, tabStyle }: TabsProps) => {
    const [direction, setDirection] = useState<'left' | 'right'>('right');
    const prevTabRef = useRef(activeTab);
    const tabIndex = tabs.findIndex(tab => tab.name === activeTab);
    const prevIndex = useRef(tabIndex);

    useEffect(() => {
        const currentIndex = tabs.findIndex(tab => tab.name === activeTab);
        if (currentIndex > prevIndex.current) {
            setDirection('right');
        } else if (currentIndex < prevIndex.current) {
            setDirection('left');
        }
        prevIndex.current = currentIndex;
        prevTabRef.current = activeTab;
    }, [activeTab, tabs]);

    return (
        <div className="tabs" style={tabsStyle}>
            {tabs.map((tab) => (
                <button 
                    key={tab.name}
                    className={`tab ${activeTab === tab.name ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab.name)}
                    style={tabStyle}
                >
                    {tab.name}
                </button>
            ))}
            <div 
                className="tab-slider" 
                style={{
                    transform: `translateX(${tabIndex * 100}%)`,
                    width: `${100 / tabs.length}%`,
                }}
            />
        </div>
    );
};